import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle } from 'lucide-react';
export function PainSection() {
  return <section className="w-full px-4 py-8 md:py-12 max-w-2xl mx-auto" data-id="element-78">
      <FadeIn data-id="element-79">
        <h2 className="text-2xl md:text-3xl font-bold text-[#2D2A26] mb-6 md:mb-8 border-b-2 border-[#7B9E6B]/20 pb-4 inline-block" data-id="element-80">
          The moment this is for
        </h2>

        <div className="prose-letter space-y-4 md:space-y-6 text-[#2D2A26]" data-id="element-81">
          <p data-id="element-82">If you've ever:</p>

          <ul className="space-y-2.5 md:space-y-3 pl-3 md:pl-4 border-l-4 border-[#FF5A5F]/25 my-4 md:my-6" data-id="element-83">
            <li className="pl-3 md:pl-4" data-id="element-84">
              Turned too fast and felt that "uh-oh" wobble
            </li>
            <li className="pl-3 md:pl-4" data-id="element-85">
              {' '}
              Held the counter just to feel normal
            </li>
            <li className="pl-3 md:pl-4" data-id="element-86">
              Avoided going out because you didn't want to look unsteady
            </li>
            <li className="pl-3 md:pl-4" data-id="element-87">
              {' '}
              Thought, "If I fall… everything changes."
            </li>
          </ul>

          <p data-id="element-88">You already know this isn't just about balance.</p>

          <p data-id="element-89">It's about trust.</p>

          <p data-id="element-90">
            Trusting your legs.
            <br data-id="element-91" />
            Trusting your steps.
            <br data-id="element-92" />
            Trusting that you can move through your day without that quiet
            background fear.
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} className="mt-10 md:mt-16" data-id="element-93">
        <div className="bg-white/50 p-5 md:p-8 rounded-2xl border border-[#2D2A26]/5 shadow-sm" data-id="element-94">
          <h3 className="text-lg md:text-2xl font-bold text-[#2D2A26] mb-4 md:mb-6 flex items-start md:items-center" data-id="element-95">
            <AlertCircle className="w-5 h-5 md:w-6 md:h-6 text-[#FF5A5F] mr-2.5 md:mr-3 flex-shrink-0 mt-0.5 md:mt-0" data-id="element-96" />
            <span data-id="element-97">Why "just walk more" doesn't fix it</span>
          </h3>

          <div className="prose-letter space-y-4 md:space-y-6 text-[#2D2A26]" data-id="element-98">
            <p data-id="element-99">
              Walking is predictable: straight line, same pace, same pattern.
            </p>

            <p data-id="element-100">But real life isn't a straight line.</p>

            <p data-id="element-101">Real life is:</p>
            <ul className="list-disc pl-5 md:pl-6 space-y-1.5 md:space-y-2 marker:text-[#7B9E6B]" data-id="element-102">
              <li data-id="element-103">Turning in the kitchen</li>
              <li data-id="element-104">Stepping sideways around a chair</li>
              <li data-id="element-105">Backing up from the sink</li>
              <li data-id="element-106">Reaching into a cabinet while your feet stay planted</li>
              <li data-id="element-107">Looking over your shoulder while you move</li>
            </ul>

            <p className="font-medium italic" data-id="element-108">
              That's where people wobble.
              <br data-id="element-109" />
              That's where fear starts.
              <br data-id="element-110" />
              And once fear starts, you move stiff… and stiffness makes you less
              stable.
            </p>

            <p data-id="element-111">It's a loop.</p>
          </div>
        </div>
      </FadeIn>
    </section>;
}